import './HardToSeeSection.scss'

const HardToSeeSection = () => (
  <section className="lnn-section lnn-section--alt lnn-hardToSeeSection">
    <div className="lnn-shell" data-reveal="up">
      <div className="lnn-hardToSeeSection__header">
        <h2>Why This Is Hard to See</h2>
        <p>By the time it becomes visible, execution has already diverged.</p>
      </div>

      <div className="lnn-hardToSeeSection__contrast">
        <article className="lnn-hardToSeeSection__panel">
          <h3>This failure does not show up in:</h3>
          <ul>
            <li>strategy decks</li>
            <li>operating models</li>
            <li>reporting systems</li>
          </ul>
        </article>

        <article className="lnn-hardToSeeSection__panel lnn-hardToSeeSection__panel--dark">
          <h3>It shows up in:</h3>
          <ul>
            <li>how directives are phrased</li>
            <li>how they are interpreted</li>
            <li>what people believe they are expected to do next</li>
          </ul>
        </article>
      </div>
    </div>
  </section>
)

export default HardToSeeSection
